import AdministrationPage from "./AdministrationPage";

export default AdministrationPage;
